import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import RadioBtn from "../../../../Button/RadioBtn";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import {
  CommentTargetContainer,
  ModalLabel,
} from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface PointTypeSelectProps {
  check: {
    first: boolean;
    second: boolean;
    third: boolean;
    fourth: boolean;
  };
  setCheck: Dispatch<
    SetStateAction<{
      first: boolean;
      second: boolean;
      third: boolean;
      fourth: boolean;
    }>
  >;
  isPoint?: boolean;
}

export default function PointTypeSelect({
  check,
  setCheck,
  isPoint,
}: PointTypeSelectProps) {
  console.log(check);

  return (
    <ModalRow
      style={{
        alignItems: "flex-start",
        flexDirection: "column",
        marginBottom: 35,
      }}
    >
      <ModalLabel>구분</ModalLabel>

      <CommentTargetContainer style={{ marginTop: 12, gap: 19 }}>
        <RadioBtnContainer>
          <RadioBtn
            label="일반 지급"
            clickEvent={() =>
              setCheck({
                first: !check.first,
                second: false,
                third: false,
                fourth: false,
              })
            }
            check={check.first}
            noTooltip={true}
          />
        </RadioBtnContainer>

        {isPoint && (
          <RadioBtnContainer>
            <RadioBtn
              label="임의 지급"
              clickEvent={() =>
                setCheck({
                  second: !check.second,
                  first: false,
                  third: false,
                  fourth: false,
                })
              }
              check={check.second}
              noTooltip={true}
            />
          </RadioBtnContainer>
        )}

        {isPoint && (
          <RadioBtnContainer>
            <RadioBtn
              label="임의 차감"
              clickEvent={() =>
                setCheck({
                  third: !check.third,
                  first: false,
                  second: false,
                  fourth: false,
                })
              }
              check={check.third}
              noTooltip={true}
            />
          </RadioBtnContainer>
        )}

        <RadioBtnContainer>
          <RadioBtn
            label="일괄 지급"
            clickEvent={() =>
              setCheck({
                fourth: !check.fourth,
                first: false,
                second: false,
                third: false,
              })
            }
            check={check.fourth}
            noTooltip={true}
          />
        </RadioBtnContainer>
      </CommentTargetContainer>
    </ModalRow>
  );
}

const RadioBtnContainer = styled.div`
  min-width: 80px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;
